<template>
    <section class="select-engine">
        <div class="configurator__container container">
            <StepBar step-name="Select your engine size" :step="4" :steps="7"/>

            <div class="configurator__flex-container">
                <div class="configurator__flex-left">
                    <Navigation
                        :go-to-step="{ name: 'select-trim', params: { brand: brand, urlModel: urlModel }, query: { id: configuratorId } }"/>

                    <ImageGallery/>
                </div>

                <div class="configurator__flex-right">
                    <Card :title="model.model_title" description="Choose your engine size:" :price="cheapestPrice">
                        <LoadingSpinner v-if="loading"></LoadingSpinner>
                        <RadioButton v-else v-model="selectedEngine" id-key="id" value-key="value" price-key="price" :options="engines" :show-prices="true" />
                    </Card>

                    <div ref="continueButton" class="configurator__continue-btn-container">
                        <button class="btn btn--primary btn--min-width btn--full-width-xs" :class="{'btn--disabled': continueDisabled}" :disbled="continueDisabled" @click="nextStep">Continue</button>
                    </div>

                    <SaveConfiguration />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import EventObject from "../../modules/tracking/EventObject";
import {mapState} from "vuex";
import scrollToElement from "../modules/scrollToElement";

export default {
    props: {
        brand: {
            type: String,
            required: true,
        },
        urlModel: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        nextStep: function () {
            if (this.continueDisabled) {
                return;
            }

            new EventObject("New Car - Configurator", "Next Step", "Clicked to Step 5 of 7: Select paint").dispatch();

            this.$router.push({
                name: "select-paint",
                params: {brand: this.brand, urlModel: this.urlModel},
                query: {id: this.configuratorId},
            });
        },
    },
    created() {
        this.$store.dispatch('getEngines').then(engines => {
            document.title = `${this.model.model_title} ${this.trimChoice} | Configure My New ${this.manufacturer} Car`

            this.$store.commit('setSelectedVehiclePrice', this.cheapestPrice);

            if (this.engines.length == 1) {
                this.selectedEngine = this.engines[0].id;
            }

            this.loading = false;
        });
    },
    computed: {
        ...mapState(["model", "vehicleId", "engineChoice", "configuratorId", "availableEngines", 'trimChoice', 'manufacturer', 'selectedVehiclePrice']),

        continueDisabled() {
            if (!this.vehicleId) {
                return true;
            }
            if (!this.engineChoice) {
                return true;
            }
            return false;
        },

        engines() {
            return this.availableEngines.map(engine => {
                return {
                    id: engine.value,
                    vehicleId: engine.id,
                    value: engine.value,
                    price: engine.pricing_display_price - this.cheapestPrice
                }
            })
        },

        selectedEngine: {
            get: function () {
                return this.$store.state.engineChoice;
            },
            set: function (selectedVehicleId) {
                for (let index = 0; index < this.engines.length; index++) {
                    const selectedVehicle = this.engines[index];
                    if (selectedVehicle.id != selectedVehicleId) {
                        continue;
                    }

                    this.$store.commit("setVehicleId", selectedVehicle.vehicleId);
                    this.$store.commit("setEngineChoice", selectedVehicle.value);
                    this.$store.commit('setSelectedVehiclePrice', selectedVehicle.price + this.cheapestPrice);
                    scrollToElement(this.$refs['continueButton']);
                    return;
                }
            },
        },

        cheapestPrice() {
            return Math.min(...this.availableEngines.map((engine) => engine.pricing_display_price))
        }
    },
};
</script>